import './components/share'

import './scss/st12/styles.scss'
